import { AppConstants } from "../config/appConstants";

export class CountryCheckHelper {
  static ifUnitedStates = (bankCountryId, bankCountries) => {
    const selectedCountryId = bankCountryId;
    if (!selectedCountryId) return false;

    // Find the selected country from the bankCountries array
    const selectedCountry = bankCountries.find(
      (country) => country?.id === selectedCountryId
    );
    if (selectedCountry && selectedCountry?.name) {
      return selectedCountry.name === AppConstants.unitedStates;
    }

    return false;
  };
}
